module.exports = "<form [formGroup]=\"group\">\r\n  <div class=\"row\">\r\n    <cco-textbox class=\"col-md-4\" label=\"Policy Holder\" name=\"policyHolderName\" formControlName=\"policyHolderName\" [group]=\"group\"></cco-textbox>\r\n    <cco-textbox class=\"col-md-4\" label=\"Loss/Claimant\" name=\"claimantName\" formControlName=\"claimantName\" [group]=\"group\"></cco-textbox>\r\n  </div>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/UI/src/app/claim/claim-list/claim-name-search/claim-name-search.component.html
// module id = ../../../../../src/app/claim/claim-list/claim-name-search/claim-name-search.component.html
// module chunks = main